import { useState } from "react";

type DocRow = {
  name: string;
  type: string;
  status: string;
  author: string;
  uploaded: string;
};

const rows: DocRow[] = [
  {
    name: "letter_reservation_of_rights_8ddf087f-3401-4bfe-b8a4-d29743cddea9.docx",
    type: "Other",
    status: "Approved",
    author: "Voltaire",
    uploaded: "03/20/2026 2:49 PM",
  },
  {
    name: "letter_reservation_of_rights_1d2ab0b2-bc97-448c-9004-2d1a801fed12.docx",
    type: "Other",
    status: "Approved",
    author: "Voltaire",
    uploaded: "03/18/2026 8:35 AM",
  },
];

export function DocumentsPage() {
  const [hover, setHover] = useState(false);

  return (
    <div>
      <div className="page-title">
        <h1>Documents</h1>
      </div>

      <div className="documents-form">
        <label>
          <span className="required">*</span>
          Related To
        </label>
        <select defaultValue="Claim">
          <option>Claim</option>
        </select>

        <label>Status</label>
        <select defaultValue="Any">
          <option>Any</option>
        </select>

        <label>Section</label>
        <select defaultValue="Any">
          <option>Any</option>
        </select>

        <label>Author</label>
        <input type="text" />

        <label>Name or Identifier</label>
        <input type="text" />

        <label>Include Hidden Documents</label>
        <div className="radio-group">
          <label>
            <input type="radio" name="hidden" />
            Yes
          </label>
          <label>
            <input type="radio" name="hidden" defaultChecked />
            No
          </label>
        </div>

        <label>Language</label>
        <select defaultValue="Any">
          <option>Any</option>
        </select>
      </div>

      <div className="documents-form-actions">
        <button className="btn btn-primary">Search</button>
        <button className="btn btn-light" style={{ color: "#2a2a2a" }}>
          Reset
        </button>
      </div>

      <div className="documents-results">
        <div className="docs-results-actions">
          <span>Search Results</span>
          <span className="clickable">Hide Documents</span>
          <button className="btn btn-primary btn-with-arrow">New Document</button>
          <span className="disabled-link">Delete Selected</span>
          <span className="right-icon">
            <button
              className="btn btn-light btn-with-arrow"
              style={{ color: "#2a2a2a", padding: "2px 8px" }}
            >
              ⊞
            </button>
          </span>
        </div>

        <table className="documents">
          <thead>
            <tr>
              <th style={{ width: 30 }}>
                <input type="checkbox" />
              </th>
              <th style={{ width: 30 }} />
              <th>
                Name<span className="sort-arrows">⇅</span>
              </th>
              <th style={{ width: 90 }}>Actions</th>
              <th>
                Document Type<span className="sort-arrows">⇅</span>
              </th>
              <th>
                Status<span className="sort-arrows">⇅</span>
              </th>
              <th>
                Author<span className="sort-arrows">⇅</span>
              </th>
              <th>
                Uploaded<span className="sort-arrows">⇅</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={row.name}>
                <td>
                  <input type="checkbox" />
                </td>
                <td>
                  <span className="doc-icon">
                    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                      <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5l-5-5H4zm5 1.5L13 5h-3a1 1 0 0 1-1-1V1.5z" />
                    </svg>
                  </span>
                </td>
                <td style={{ position: "relative" }}>
                  <a
                    href="#"
                    onMouseEnter={() => i === 0 && setHover(true)}
                    onMouseLeave={() => i === 0 && setHover(false)}
                  >
                    {row.name}
                  </a>
                  {i === 0 && hover && (
                    <div className="tooltip" style={{ top: -22, left: 90 }}>
                      View document content
                    </div>
                  )}
                </td>
                <td>
                  <span className="action-icons">
                    <span className="icon-link" title="Info">
                      <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12zm0-9.5A1 1 0 1 1 8 6a1 1 0 0 1 0-1.5zM7.5 7h1v5h-1V7z" />
                      </svg>
                    </span>
                    <span className="icon-link" title="Document">
                      <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5l-5-5H4z" />
                      </svg>
                    </span>
                    <span className="icon-link" title="Copy">
                      <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M4 1a1 1 0 0 0-1 1v1h1V2h7v10h-1v1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H4zM1 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4zm1 0v10h7V4H2z" />
                      </svg>
                    </span>
                    <span className="icon-link" title="Delete">
                      <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3h11V2h-11v1z" />
                      </svg>
                    </span>
                  </span>
                </td>
                <td>{row.type}</td>
                <td>{row.status}</td>
                <td>{row.author}</td>
                <td>{row.uploaded}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
